// Cards beside the promo slot: what `.card-3d-model` fits at that width, minus the promo.
const CARDS_BY_BREAKPOINT = {
  xs: 0,
  sm: 1,
  md: 3,
  lg: 3,
  xl: 4,
  xxl: 5,
}

// The skeleton emits all of them; `__skeleton-card` rules in _upsell-block.scss hide the rest.
export const MAX_CARD_COUNT = Math.max(...Object.values(CARDS_BY_BREAKPOINT))

export function getCardCount(breakpoint) {
  return CARDS_BY_BREAKPOINT[breakpoint] ?? 0
}
